import axios from 'axios';

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001';

export interface AdminUser {
  username: string;
  isAuthenticated: boolean;
}

export interface AdminAuthResponse {
  access_token: string;
  admin: {
    username: string;
    role: string;
  };
}

export async function loginAdmin(
  username: string,
  password: string
): Promise<AdminAuthResponse> {
  const response = await axios.post<AdminAuthResponse>(`${API_URL}/auth/admin/login`, {
    username,
    password,
  });
  return response.data;
}

export async function changeAdminPassword(
  currentPassword: string,
  newPassword: string
): Promise<{ message: string }> {
  const token = getAccessToken();
  const response = await axios.post(
    `${API_URL}/auth/admin/change-password`,
    { currentPassword, newPassword },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('amam_admin_token');
}

export function setAccessToken(token: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem('amam_admin_token', token);
}

export function clearAccessToken(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('amam_admin_token');
}

export function getAdminSession(): AdminUser | null {
  if (typeof window === 'undefined') return null;

  const session = localStorage.getItem('amam_admin_session');
  if (!session) return null;

  try {
    return JSON.parse(session);
  } catch {
    return null;
  }
}

export function setAdminSession(user: AdminUser): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem('amam_admin_session', JSON.stringify(user));
}

export function clearAdminSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('amam_admin_session');
  clearAccessToken();
}
